/* eslint-disable no-unused-vars */
import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import app from './app-dux/app-dux';
import company from './app-dux/company-dux';
import permissions from './app-dux/permissions-dux';
import policies from './app-dux/policies-dux';
import roles from './app-dux/roles-dux';
import people from './app-dux/people-dux';

/*******************************************************************************
 *  Gather all the reducers
 */
const reducer = combineReducers( {
    app,
    company,
    permissions,
    policies,
    roles,
    people
} );

const middleware = [ thunk ];
    middleware.push( createLogger( {
        collapsed: true
    } ) );

const AppStore = createStore(
    reducer,
    applyMiddleware( ...middleware )
);
export default AppStore;
